export const ADD_NEW_BOOK = 'books/addBook'
export const SET_BOOKS = 'books/setBooks'
export const UPDATE_BOOK = 'books/updateBook'
export const SELECT_FOR_UPDATE = 'books/selectForUpdate'
export const DELETE_BOOKS = 'books/delete'
